import React from 'react';
import Button from '../Button/Button';
import { Flex, FlexProps } from 'rebass';

type ModalFooterProps = FlexProps;

const defaultModalFooterChildren = (
  <>
    <Button icon="plus">Save</Button>
    <Button ml={3} variant="outline" icon="plus">
      Cancel
    </Button>
  </>
);

const ModalFooter = (props: ModalFooterProps): JSX.Element => (
  <Flex
    py={2}
    px={4}
    {...(props as any)}
    sx={{
      gap: 2,
      ...(props.sx as any),
      justifyContent: 'flex-end',
      flexGrow: 0,
      flexShrink: 0,
      borderTop: 1,
      borderTopStyle: 'solid',
      borderColor: 'fieldBorder',
    }}
  >
    {props.children ?? defaultModalFooterChildren}
  </Flex>
);

export default ModalFooter;
